export default "__VITE_ASSET__YAnr66iM__"